import { ISensitiveSettings, SensitiveSettingsStorageBase } from 'web-core-src';

export abstract class SensitiveSettingsBase implements ISensitiveSettings {
    public abstract init(): void;

    public abstract setDefaultValues(): void;
    public abstract translateDefaultValues(): void;

    public version: string;
    public settingsStorage: SensitiveSettingsStorageBase;

    public setAppSettings(settingsJsonString: string): void {
        this.settingsStorage.setAppSettings(settingsJsonString);
    }

    public getAppSettings(): ISensitiveSettings {
        return this.settingsStorage.getAppSettings();
    }

    public async loadSettingsFromStorage(): Promise<void> {
        return this.settingsStorage.loadSettingsFromStorage();
    }

    public updateSettingsInStorage(): void {
        this.settingsStorage.updateSettingsInStorage();
    }

    public getCurrentSettingsJSON(): string {
        return this.settingsStorage.getCurrentSettingsJSON();
    }
}
